import React, { useState, useEffect } from "react";
import ApiMethods from "../../../../ApiManager/ApiMethods";
import { IconButton } from "@mui/material";
import { CheckCircle, Cancel, AccessTime } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";

function Agenda({ activeClientId, setOpenAgenda }) {
  const [appointments, setAppointments] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10; // items per page

  const fetchAppointments = async (pageNumber) => {
    try {
      const res = await ApiMethods.get(
        `auth/appointments?past=true&page=${pageNumber}&limit=${limit}&clientId=${activeClientId}`
      );

      console.log("ressss", res);
      const { data, totalPages } = res;

      setAppointments(data);
      setTotalPages(totalPages);
    } catch (err) {
      console.error("Error fetching appointments:", err);
    }
  };

  useEffect(() => {
    fetchAppointments(page);
  }, [page]);

  const handlePrev = () => {
    if (page > 1) setPage(page - 1);
  };

  const handleNext = () => {
    if (page < totalPages) setPage(page + 1);
  };

  const statusIcon = (status) => {
    switch (status) {
      case "book":
        return <CheckCircle color="success" />;
      case "canceled":
        return <Cancel color="error" />;
      case "noshow":
        return <AccessTime color="warning" />;
      default:
        return null;
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case "book":
        return "Zakazano";
      case "canceled":
        return "Otkazano";
      case "noshow":
        return "Nije se pojavio";
      default:
        return status; // Fallback to the status if no match
    }
  };

  return (
    <div className="agenda-part">
      <div className="centered-modal">
        <div className="appointments-list">
          <CloseIcon
            onClick={setOpenAgenda}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              cursor: "pointer",
              color: "black",
            }}
          />
          <ul>
            {appointments.map((a) => (
              <li
                key={a.id}
                className="list-agenda"
                style={{
                  maxHeight: "50px",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",

                  borderTop: "1px solid #ccc", // Top separator
                  borderBottom: "1px solid #ccc", // Bottom separator
                  // border: `2px solid ${
                  //   a.status === "book"
                  //     ? "green"
                  //     : a.status === "canceled"
                  //     ? "red"
                  //     : "orange"
                  // }`,
                  borderRadius: "8px",
                  padding: "1rem",
                  margin: "0.5rem 0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <div
                    style={{
                      fontWeight: "bold",
                      fontSize: "16px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {a.title} –{" "}
                    {(() => {
                      const date = new Date(a.start);
                      if (isNaN(date)) {
                        console.error("Invalid date:", a.start);
                        return ""; // Handle invalid date case
                      }

                      const dateString = date.toLocaleDateString("sr-RS", {
                        day: "numeric",
                        month: "short",
                        weekday: "short",
                      });

                      if (dateString) {
                        const parts = dateString.split(", ");
                        const dayMonth = parts[0];
                        const weekday = parts[1];
                        const capitalize = (s) =>
                          s ? s.charAt(0).toUpperCase() + s.slice(1) : "";

                        return `${dayMonth}, ${capitalize(weekday)}`;
                      } else {
                        console.error("Invalid date string:", dateString);
                        return ""; // Fallback case
                      }
                    })()}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  {statusIcon(a.status)}
                  <span
                    style={{
                      color:
                        a.status === "book"
                          ? "green"
                          : a.status === "canceled"
                          ? "red"
                          : "orange",
                    }}
                  >
                    {getStatusLabel(a.status)}
                  </span>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* Pagination Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "1rem",
            marginTop: "1rem",
          }}
        >
          <button
            onClick={handlePrev}
            disabled={page === 1}
            style={{
              background:
                "var(--Red-2, linear-gradient(90deg, #ec0707 0%, #774b4b 100%))",
              color: "white",
              border: "none",
              padding: "8px 16px",
              whiteSpace: "nowrap",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            ← Preth
          </button>
          <span
            style={{
              whiteSpace: "nowrap",
              fontSize: "15px",
              lineHeight: "30px",
            }}
          >
            Strana {page} od {totalPages}
          </span>
          <button
            onClick={handleNext}
            disabled={page === totalPages}
            style={{
              whiteSpace: "nowrap",
              background:
                "var(--Red-2, linear-gradient(90deg, #ec0707 0%, #774b4b 100%))",
              color: "white",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            Sled →
          </button>
        </div>
      </div>
    </div>
  );
}

export default Agenda;
